module.exports = __webpack_public_path__ + "static/media/insulation_lcs_60y_y.32daefe7.csv";